export default __webpack_public_path__ + "static/media/file-video_darkGray1.5ba85ac0.svg";